import { SpecialOfferProps } from '../types';
import { Box } from '@mui/system';
import { BundlePrice } from 'components/BundlePrice';
import { EBundlesInternalViewModel } from 'utils/enums';
import { StyledPipaSpecialOffer } from './style';
import { PipaMainProduct } from './Products/PipaMainProduct';
import { PipaSubProduct } from './Products/PipaSubProduct';
import { useEffect, useState } from 'react';
import { ProductData } from 'utils/types';

export const PipaSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  backgroundColor,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  isFree,
  collectText,
  timer,
  availabilityText,
  availability,
  inMobileMock = false,
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProduct, setSubProduct] = useState<ProductData[]>([]);

  useEffect(() => {
    if (productsList.length > 0) {
      setMainProduct(productsList[0]);
    }
    if (productsList.length > 1) {
      setSubProduct(productsList.slice(1, 3));
    }
  }, [productsList]);

  return (
    <StyledPipaSpecialOffer
      onClick={selectOffer}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      isPreview={inMobileMock}
      data-testid={dataTestId}
    >
      <Box className="container">
        {productsList.length > 0 && (
          <Box className="products">
            <Box className="products-container">
              {mainProduct && (
                <Box className="products-container--main-image">
                  <img
                    src={mainProduct.images.product}
                    alt="main-product"
                    className="image"
                  />
                </Box>
              )}
              <Box className="products-container--products">
                <Box className="product--main">
                  {mainProduct && (
                    <PipaMainProduct
                      quantityDisplay={mainProduct.quantityDisplay}
                      isMainProduct={
                        !!(
                          salePercentage > 0 && mainProduct.strokedSaleQuantity
                        )
                      }
                      textColor={mainProduct.textFontColorHex}
                      strokedSaleQuantity={mainProduct.strokedSaleQuantity}
                    />
                  )}
                </Box>
                {subProduct.length > 0 && (
                  <Box className="product--sub-list">
                    {subProduct.map(
                      (
                        { textFontColorHex, images, quantityDisplay },
                        index,
                      ) => (
                        <PipaSubProduct
                          key={index}
                          textColor={textFontColorHex}
                          productImage={images.product}
                          quantityDisplay={quantityDisplay}
                        />
                      ),
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}
        <BundlePrice
          prices={prices}
          type={EBundlesInternalViewModel.PIPA}
          isFree={isFree}
          buttonText={collectText}
          availabilityText={availabilityText}
          availability={availability}
          timer={timer}
        />
      </Box>
    </StyledPipaSpecialOffer>
  );
};
